import React from 'react';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  active?: boolean;
}

const WohnungBestandIcon: React.FC<IconProps> = ({
  className,
  style,
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      viewBox="930 500 40 40"
      width={width}
      height={height}
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M938 540V504C938 503.46 938 502.9 938.14 502.36C938.262 501.821 938.533 501.328 938.922 500.935C939.311 500.543 939.802 500.267 940.34 500.14C940.92 500 943.46 500 944 500H958C958.54 500 959.1 500 959.64 500.14C960.179 500.262 960.672 500.533 961.065 500.922C961.457 501.311 961.733 501.802 961.86 502.34C962 502.9 962 503.46 962 504V540H938Z"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M930 524V536C930 538.2 931.8 540 934 540H938V520H934C933.46 520 932.9 520 932.36 520.14C931.82 520.28 931.32 520.54 930.92 520.94C930.54 521.32 930.28 521.82 930.14 522.36C930.027 522.899 929.98 523.45 930 524Z"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M967.64 514.14C967.101 514.027 966.55 513.98 966 514H962V540H966C967.061 540 968.078 539.579 968.828 538.828C969.579 538.078 970 537.061 970 536V518C970 517.44 970 516.9 969.86 516.36C969.72 515.82 969.46 515.32 969.06 514.92C968.68 514.54 968.18 514.28 967.64 514.14Z"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M946 508H954"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M946 516H954"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M946 524H954"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M946 532H954"
      />
    </svg>
  );
};

export default WohnungBestandIcon;
